import { mapWritableState } from 'pinia'
import { usePhonesStore } from '@/stores/PhonesStore'
import { findIndex } from 'lodash'
import Vue from 'vue'

export default {

    computed: {

        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
            currentSelectedConfigurationIndex: 'currentSelectedConfigurationIndex',
        }),

    },
    methods: {

        appDelete (packageId, device) {

            let self = this

            // let currentApplications = self.configurations[self.currentSelectedConfigurationIndex].value.applications
            let appIndex = self.appsGetIndex(self.currentSelectedConfigurationIndex, packageId)

            // Delete all time conditions for this application prior deleting the application
            // We are doing this because, if we delete the application, the time condition will still be there. This is observed when the app is installed again from the app store via double click. For now this is required.
            if(self.configurations[self.currentSelectedConfigurationIndex].value.applications[appIndex].hasOwnProperty('time_condition')){
                delete self.configurations[self.currentSelectedConfigurationIndex].value.applications[appIndex].time_condition
            }

            // Remove the application from the list of applications
            self.configurations[self.currentSelectedConfigurationIndex].value.applications.splice(appIndex, 1)


            /* const appsAfterDelete = currentApplications.filter(function (phone) {
                return phone.packageId !== packageId
            })

            // Otherwise it is not reflecting instantly, we must right-click again to receive the update, and see the reactivity
            self.$set(self.configurations[self.$props.currentSelectedConfigurationIndex].value, 'applications', appsAfterDelete)*/

            self.$emit('forceReRender')

        },

        appsGetIndex (currentSelectedConfigurationIndex, packageId) {

            let self = this

            let index = findIndex(self.configurations[currentSelectedConfigurationIndex].value.applications, { packageId: packageId })

            return index
        }

    }
}
